module.exports = __webpack_public_path__ + "static/media/Cover3.ff10c2ca.png";